import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@material-ui/core';
import Avatar from 'sharedComponents/Avatar';

const AvatarWithBadge = props => {
  const { className, isOnline, ...rest } = props;

  return (
    <Badge
      color={isOnline ? 'primary' : 'secondary'}
      overlap="circular"
      badgeContent=""
      variant="dot"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      className={className}
    >
      <Avatar {...rest} />
    </Badge>
  );
};

AvatarWithBadge.propTypes = {
  isOnline: PropTypes.bool,
  className: PropTypes.string,
};

AvatarWithBadge.defaultProps = {
  isOnline: false,
  className: '',
};

export default AvatarWithBadge;



// WEBPACK FOOTER //
// ./src/sharedComponents/AvatarWithBadge/AvatarWithBadge.js